import { render, staticRenderFns } from "./playerPerformance.vue?vue&type=template&id=1221be41&scoped=true&"
import script from "./playerPerformance.vue?vue&type=script&lang=js&"
export * from "./playerPerformance.vue?vue&type=script&lang=js&"
import style0 from "./playerPerformance.vue?vue&type=style&index=0&id=1221be41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221be41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
